module.exports = __webpack_public_path__ + "img/b1.51e515b0.jpg";